/* eslint-disable */

import { Fragment, useState } from "react";
import ModalComponent from "../modal";
import styled from "styled-components";
import BadgeComponent from "../badge";
import { Stack } from "@mui/material";
import ButtonComponent from "../button";
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CardPrimaryComponent from "../card-primary";
import moment from "moment";

const CardStatusModalWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const StyledTabContentLabel = styled.p`
    font-size: 14px;
`;

const StyledTabContentValue = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color-primary);
`;

// const StyledHistoryContent = styled(Stack)`
//     background-color: var(--theme-color-secondary);
//     padding: 14px 20px;
//     border-radius: 20px;
//     gap: 4px;

//     p {
//         font-size: 14px;

//         span {
//             color: var(--text-color-primary);
//             font-weight: 700;
//         }
//     }
// `;

const ViewCardStatusFileImportLogsModal = ({ data, close, label, slide }) => {

    const cardStats = [
        { label: 'Total Records', value: data?.totalRecords || 0, customColor: undefined },
        { label: 'Valid Records', value: data?.validRecords || 0, customColor: 'success' },
        { label: 'Invalid Records', value: data?.invalidRecords || 0, customColor: 'error' },
        { label: 'Applied', value: data?.appliedRecords || 0, customColor: 'warning' },
    ];

    const getBadgeType = (value) => {
        const statusMap = {
            'active': 'success',
            'warm': 'warning',
            'hot': 'error'
        };
        return statusMap[value?.toLowerCase()] || 'default';
    };

    const FileDetails = () => {
        const fileData = [
            // { label: 'Type', type: 'text', value: data?.type },
            { label: 'Received At', type: 'text', value: moment(data?.receiveAt).format('lll') },
            { label: 'Status', type: 'badge', value: data?.status?.toLowerCase() },
        ];

        if (!fileData || fileData.length === 0) return null;

        return (
            <Stack spacing={4} p={2}>
                <Stack spacing={2}>
                    <h6>File Details</h6>
                    <Stack spacing={1}>
                        {fileData.map((item, idx) => (
                            <Stack key={idx} direction="row" flexWrap="wrap" justifyContent="space-between">
                                <StyledTabContentLabel>{item.label}</StyledTabContentLabel>
                                {item.type === 'badge' ? (
                                    <BadgeComponent label={item.value} type={getBadgeType(item.value)} />
                                ) : (
                                    <StyledTabContentValue>{item.value}</StyledTabContentValue>
                                )}
                            </Stack>
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        );
    };

    // const CONTROLS = () => {
    //     const controlsData = [
    //         {
    //             section: 'MCC Block List',
    //             data: data?.mccBlocks || [],
    //         },
    //         {
    //             section: 'Country Block List',
    //             data: data?.countryBlocks || [],
    //         },
    //     ];
    //     return (
    //         <Stack spacing={4} p={2}>
    //             {
    //                 controlsData.map((section, index) => (
    //                     <Stack key={index} spacing={1}>
    //                         <h6>{section.section}</h6>
    //                         <Stack direction="row" flexWrap="wrap" gap={1}>
    //                             {
    //                                 section.data.map((item, idx) => (
    //                                     <Fragment key={idx}>
    //                                         <BadgeComponent label={item} type='error' />
    //                                     </Fragment>
    //                                 ))
    //                             }
    //                         </Stack>
    //                     </Stack>
    //                 ))
    //             }
    //         </Stack>
    //     );
    // };

    // const HISTORY = () => {
    //     return (
    //         <Stack spacing={1} p={2}>
    //             {
    //                 [...Array(3)].map((_, index) => (
    //                     <StyledHistoryContent key={index} className="box-shadow">
    //                         <p><span>Updated</span> {'Oct 27, 2025 15:15'}</p>
    //                         <p>By {'system@ingest'}</p>
    //                         <p>Source: {'FILE'}</p>
    //                     </StyledHistoryContent>
    //                 ))
    //             }
    //         </Stack>
    //     );
    // };

    return (
        <ModalComponent close={close} label={label} width={600} slide={slide}>
            <CardStatusModalWrapper>
                {/* head */}
                {
                    (data?.id || data?.name) &&
                    <>
                        <Stack spacing={2}>
                            <Stack spacing={0.3}>
                                {
                                    data?.id &&
                                    <h5>File ID: {data?.id}</h5>
                                }
                                {
                                    data?.name &&
                                    <p>File Name: {data?.name}</p>
                                }
                            </Stack>
                            {/* <Stack direction="row" flexWrap="wrap" gap={1}>
                        <BadgeComponent label={data?.status} type={
                            data?.status?.toLowerCase() === 'active' ? 'success' :
                                data?.status?.toLowerCase() === 'warm' ? 'warning' :
                                    data?.status?.toLowerCase() === 'hot' ? 'error' :
                                        'default'
                        } />
                        <BadgeComponent label={data?.enrolled ? 'Enrolled' : 'Not Enrolled'} type={data?.enrolled ? 'success' : 'error'} />
                    </Stack> */}
                        </Stack>
                        <Divider />
                    </>
                }

                <Box>
                    <Grid container spacing={1}>
                        {cardStats.map((card, index) => (
                            <CardPrimaryComponent
                                key={index}
                                label={card.label}
                                value={card.value}
                                size="small"
                                customColor={card.customColor}
                            />
                        ))}
                    </Grid>
                    <FileDetails />
                </Box>

                {/* <Stack direction="row" flexWrap="wrap" justifyContent="flex-end">
                    <ButtonComponent label="Close" type="button" onClick={close} />
                </Stack> */}
            </CardStatusModalWrapper>
        </ModalComponent>
    );
};

export default ViewCardStatusFileImportLogsModal;
